import React from 'react';
import { Card, Button } from 'reactstrap';
import moment from 'moment';
import { DATE_FORMAT } from '../../../constants';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const TaskAbout = (props) => {
    if (!props.case) {
        return (
            <div></div>
        )
    }
    return (
        <Card className="mb-4">
            <table className="table table-bordered border-bottom-0 case-about-table">
                <thead className="header-blue">
                    <tr>
                        <th width="20%">Case Id</th>
                        <th width="25%">Company Name</th>
                        <th width="35%">Address</th>
                        <th width="10%">Placed on</th>
                        <th width="10%">Due date</th>
                        {/* <th width="10%">Status</th> */}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="text-truncate">
                            <CopyToClipboard text={props.case.caseId}>
                                <Button color="link" size="sm" title="Copy Case Id to clipbard">
                                    <i className="fa fa-copy" />
                                </Button>
                            </CopyToClipboard>
                            &nbsp;
                            {props.case.caseId}
                        </td>
                        <td title={props.case.companyName} className="text-truncate"> {props.case.companyName} </td>
                        <td title={props.case.address} className="text-truncate"> {props.case.address} </td>
                        <td title={props.case.placedOn}> {props.case.placedOn ? moment(props.case.placedOn).format(DATE_FORMAT) : ''} </td>
                        <td title={props.case.deliveryDate}> {props.case.deliveryDate ? moment(props.case.deliveryDate).format(DATE_FORMAT) : ''} </td>
                        {/* <td> {props.case.status} </td> */}
                    </tr>
                </tbody>
            </table>
        </Card>
    )
}
export default TaskAbout;